import { BPButton } from '@/components/bp/bpbutton';
import { CaseRunClient, ProfileSummaryTableModel } from '@app/api2/api';
import { max } from 'lodash';
import * as React from 'react';
import { Button, Icon, Segment, Table, TableBody, TableCell, TableHeader, TableHeaderCell, TableRow } from 'semantic-ui-react';

interface IDeconvProfileSummaryTableProps {
    labId: number;
    caseId: number;
    caseRunId: number;
    format: 'genotype' | 'allele'
}

export const DeconvProfileSummaryTable: React.FunctionComponent<IDeconvProfileSummaryTableProps> = (props) => {
    const client = new CaseRunClient()
    const [model, setModel] = React.useState<ProfileSummaryTableModel>()

    React.useEffect(() => {
        async function fetch() {
            const result = await client.getDeconvolutionTable(props.labId, props.caseId, props.caseRunId, props.format);

            setModel(result);
        }

        fetch();
    }, [props.labId, props.caseRunId, props.caseId])

    const evNames = model?.evidence ? model.evidence.map(m => m.name) : [];
    const sysNames = evNames?.length > 0 ? model.evidence[0].systems.map(m => m.name) : [];
    const sysColors = evNames?.length > 0 ? model.evidence[0].systems.map(m => m.color) : [];
    const evColSpan = max(model?.evidence.map(x => max(x.systems.map(s => s.alleles.length))))

    return <><Segment>
        <BPButton className='print-hide' icon onClick={() => {
            copyWithStyle(`tbl_${props.format}`);
        }}><Icon name={'copy'} /> {window.translation.common.copyToClipboard}</BPButton>

        <table id={`tbl_${props.format}`}  className='pst'>
            <TableHeader>
                <TableRow>
                    <TableHeaderCell>{window.translation.common.locus}</TableHeaderCell>
                    {model?.evidence?.map(evName => (
                        <TableHeaderCell className='separator' key={`ev_${evName.name}_header`} colSpan={evColSpan}>{evName.name}</TableHeaderCell>
                    ))}
                    {model?.contributors.map(evName => (
                        <TableHeaderCell className='separator' key={`contr_${evName.name}_header`} colSpan={2}>{evName.name}</TableHeaderCell>
                    ))}
                    {model?.deconvSamples.map(evName => (
                        <TableHeaderCell className='separator' key={`deconv_${evName.name}_header`} colSpan={2}>{evName.name}</TableHeaderCell>
                    ))}
                </TableRow>
            </TableHeader>
            <TableBody>
                {sysNames.map((sysName, ri) => (
                    <TableRow key={sysName} className={sysColors[ri]}>
                        <TableCell>
                            {sysName}
                        </TableCell>
                        {model?.evidence?.map(evName => {
                            const alleles = evName.systems.find(s => s.name == sysName)?.alleles ?? [];
                            const emptyCellCount = evColSpan - alleles.length

                            return alleles.concat([...Array(emptyCellCount).keys()].map(m => { return { allele: "", isAboveThreshold: true } })).map((allele, ai) => (
                                <TableCell textAlign={'center'} verticalAlign={'middle'} className={(ai == 0 ? 'separator' : '')} key={`ev_${evName.name}_${sysName}_${ai}`} disabled={!allele.isAboveThreshold}>{allele.allele}</TableCell>
                            ))
                        })}
                        {model?.contributors?.map(evName => {
                            const alleles = evName.systems.find(s => s.name == sysName)?.alleles ?? [];
                            const emptyCellCount = 2 - alleles.length

                            return alleles.concat([...Array(emptyCellCount).keys()].map(m => { return { allele: "", isAboveThreshold: true } })).map((allele, ai) => (
                                <TableCell textAlign={'center'} verticalAlign={'middle'} className={(ai == 0 ? 'separator' : '')} key={`con_${evName.name}_${sysName}_${ai}`}>{allele.allele}</TableCell>
                            ))
                        })}
                        {model?.deconvSamples?.map(evName => {
                            const alleles = evName.systems.find(s => s.name == sysName)?.alleles ?? [];
                            const emptyCellCount = 2 - alleles.length

                            return alleles.concat([...Array(emptyCellCount).keys()].map(m => { return props.format == 'genotype' ? { allele: "", isAboveThreshold: true } : { allele: "*", isAboveThreshold: true } })).map((allele, ai) => (
                                <TableCell textAlign={'center'} verticalAlign={'middle'} className={(ai == 0 ? 'separator' : '')} key={`dec_${evName.name}_${sysName}_${ai}`}>{allele.allele}</TableCell>
                            ))
                        })}
                    </TableRow>
                ))}
            </TableBody>
        </table>
    </Segment></>;
};

const copyWithStyle = (element) => {

    const doc = document;
    const text = doc.getElementById(element);
    let range;
    let selection;

    selection = window.getSelection();

    range = doc.createRange();
    range.selectNodeContents(text);

    selection.removeAllRanges();
    selection.addRange(range);

    document.execCommand('copy');
    window.getSelection().removeAllRanges();
}